import genererIntervenantContrat from '@/services/baux/contrat/genererIntervenantContrat';
import store from '@/store/store';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import booleanConverter from '@/services/import/General/booleanConverter';
import isNaN from '@/services/general/isNan';

export default function genererIntervenants(bail, bailleursOfBail, bailleursInBase) {
  const bailleursCodes = [...new Set(bailleursOfBail.map(b => b.codeBailleur))];
  bailleursCodes.forEach(code => {
    const ligneBailleur = bailleursOfBail.find(b => b.codeBailleur === code);
    const bailleurReference = bailleursInBase.find(b => b.referenceExterne
      === ligneBailleur.codeBailleur.toString());
    const intervenant = genererIntervenantContrat();
    intervenant.tiers = bailleurReference;
    let modeReglement;
    if (ligneBailleur.modePaiementBailleur) {
      modeReglement = store.getters['parametres/parametre'](PARAMETRES_KEYS.modeReglement).find((modeReglement) => {
        return modeReglement.libelle.toLowerCase().trim()
          === ligneBailleur.modePaiementBailleur.toLowerCase().trim();
      });
    } else {
      modeReglement = store.getters['parametres/parametre'](PARAMETRES_KEYS.modeReglement).find((modeReglement) => {
        return modeReglement.id === bailleurReference.modeReglementId;
      });
    }
    intervenant.modeReglementId = modeReglement ? modeReglement.id : null;
    intervenant.modeReglement = modeReglement ? modeReglement.libelle : null;
    let quotePart = 0;
    ligneBailleur.quotePart = ligneBailleur.quotePart.toString();
    if (ligneBailleur.quotePart.includes('%')) ligneBailleur.quotePart = ligneBailleur.quotePart.replace('%', '');
    quotePart = parseFloat(ligneBailleur.quotePart.trim());
    if (isNaN(quotePart)) quotePart = 0;
    intervenant.repartition = quotePart;
    intervenant.tiersId = bailleurReference.id;
    intervenant.surFacture = ligneBailleur.paiementSurFacture === 0
      ? false : booleanConverter(ligneBailleur.paiementSurFacture);

    bail.intervenants.push(intervenant);
  });
}
